import {
  OPERATING_INDICATOR_TYPE_ATOM,
  OPERATING_PLOT_TYPE,
  OPERATING_SELECTED_YEAR_ATOM,
} from "components/stocks/modern/OperatingSegments/atoms";
import { useAtom, useAtomValue, useSetAtom } from "jotai";

export const useSelectedYearValue = () => useAtomValue(OPERATING_SELECTED_YEAR_ATOM);
export const useSelectedYear = () => useAtom(OPERATING_SELECTED_YEAR_ATOM);
export const useSetSelectedYear = () => useSetAtom(OPERATING_SELECTED_YEAR_ATOM);

export const useIndicatorTypeValue = () => useAtomValue(OPERATING_INDICATOR_TYPE_ATOM);
export const useIndicatorType = () => useAtom(OPERATING_INDICATOR_TYPE_ATOM);
export const useSetIndicatorType = () => useSetAtom(OPERATING_INDICATOR_TYPE_ATOM);

export const usePlotTypeValue = () => useAtomValue(OPERATING_PLOT_TYPE);
export const usePlotType = () => useAtom(OPERATING_PLOT_TYPE);
export const useSetPlotType = () => useSetAtom(OPERATING_PLOT_TYPE);
